import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SessionExpiredComponent } from "../../components/session-expired/session-expired.component";
import { LoginGuardService } from "../../services/login-guard/login-guard.service";
import { WelcomeComponent } from "src/app/components/welcome/welcome.component";
import { CustomerAcknowledgementFormComponent } from "src/app/components/customer-acknowledgement-form/customer-acknowledgement-form.component";
import { ConsentComponent } from "src/app/components/consent/consent.component";

let routes: Routes = [];
let childRoutes = [];

childRoutes = [
  {
    path: "customer-acknowledgement",
    component: CustomerAcknowledgementFormComponent,
  }
];

routes = [
  {
    path: "",
    component: WelcomeComponent,
    canActivate: [LoginGuardService],
    children: childRoutes
  },
  {
    path: "",
    redirectTo: "customer-acknowledgement",
    pathMatch: "full",
  },
  {
    path: "consent-acknowledgement",
    component: ConsentComponent,
  },
  {
    path: "session-expired",
    component: SessionExpiredComponent,
  },
  {
    path: "**",
    redirectTo: "customer-acknowledgement",
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class RoutingModule { }
